


var g_activeAnimation;
var scrollTop = {};

//easeInOutCubic animation included in the library
Math.easeInOutCubic = function (t, b, c, d) {
  if ((t/=d/2) < 1) return c/2*t*t*t + b;return c/2*((t-=2)*t*t + 2) + b;
};

scrollTop.stop = function(){
  g_activeAnimation = false;
};

/**
 * Simulates the animated scrollTop of jQuery. Used when css3:false or scrollBar:true or autoScrolling:false
 * http://stackoverflow.com/a/16136789/1081396
 */
scrollTop.scrollTo = function(params) {
  var element = typeof params.element !== 'undefined' ? params.element : window;
  var to = params.to;
  var duration = typeof params.duration !== 'undefined' ? params.duration : 700;
  var callback = typeof params.callback !== 'undefined' ? params.callback : null;
  var easing = typeof params.easing !== 'undefined' ? params.easing : Math.easeInOutCubic;

  var start = (window.pageYOffset || document.documentElement.scrollTop)  - (document.documentElement.clientTop || 0);
  var change = to - start;
  var currentTime = 0;
  var increment = 16; //same amount of milliseconds as requestAnimationFrame
  g_activeAnimation = true;

  var animateScroll = function() {
    //in case we want to stop it from other function whenever we want
    if (g_activeAnimation) {
      currentTime += increment;
      element.scrollTo(0, easing(currentTime, start, change, duration));

      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      } else if (callback){
        callback();
      }
    }else if (currentTime < duration && callback){
      callback();
    }
  };

  animateScroll();
};

//quick方法
scrollTop.qScroll = function(y){
  scrollTop.scrollTo({
    element: window,
    to: y,
    duration: 600,
    callback: function() {
      console.log("finished!");
    }
  });
}


export default  scrollTop;



// WEBPACK FOOTER //
// ./src/tools/scrollTop.js